<template>
    <section class="tables new-updated-design px-0 px-md-0 pt-4 pt-md-0">
        <vue-snotify></vue-snotify>
        <div>
            <b-modal id="offer-detail-modal" ref="offer-detail-modal" :title="$t('offers.offers_detail')" size="xl"
                :ok-title="$t('sweetalert.OK')" :cancel-title="$t('sweetalert.cancel')" class="offer-detail-modal">
                <div v-if="selectedOffer" class="offer-detail-modal-content">
                    <!-- Offer Table Section -->
                    <div class="offer-detail-modal-table">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title m-0">{{ $t('offers.Offer_Details') }}</h4>
                            </div>
                            <div class="card-body">
                                <div class="row row-border">
                                    <div class="col-sm-6 col-md-4">
                                        <p><span class="font-weight-bolder">{{ $t('register.name') }}:</span> {{
                                            selectedOffer.user.name }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('login.email') }}:</span> {{
                                            selectedOffer.user.email }}</p>

                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <p><span class="font-weight-bolder">{{ $t('property_detail.Property_Type')
                                                }}:</span> {{ selectedOffer.property.property_type }}</p>
                                        <p><span class="font-weight-bolder">{{
                                            $t('Propertis.Accommodation_Type_Reserved') }}:</span> {{
                                            selectedOffer.property.accommodation_type }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.Property_Address')
                                                }}:</span> {{ selectedOffer.property.address }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('properties_list.city') }}:</span> {{
                                            selectedOffer.property.city }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('property_detail.Country') }}:</span>
                                            {{ selectedOffer.property.country }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('property_detail.Description')
                                                }}:</span> {{ selectedOffer.property.property_description }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('property_detail.Price') }}:</span>
                                            {{ selectedOffer.property.currency }} {{
                                                selectedOffer.property.price_per_month
                                            }}/{{ $t('property_detail.month') }}</p>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <p><span class="font-weight-bolder">
                                                {{ $t('offers.total_price') }}

                                                <span class="tooltip-container ml-1">
                                                    <span class="info-icon">ℹ️</span>
                                                    <span class="tooltip-text">{{ $t('offers.total_price_hint')
                                                        }}</span>
                                                </span>
                                                :
                                            </span>
                                            {{ selectedOffer.currency }} {{ selectedOffer.original_price }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('offers.offered_price') }}:</span>
                                            {{ selectedOffer.currency }} {{ selectedOffer.offered_price }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.Length_of_Stay') }}:</span>
                                            {{ selectedOffer.no_of_days }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.number_of_guests')
                                                }}:</span>
                                            {{ selectedOffer.no_of_guests }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.start_date') }}:</span>
                                            {{ formatDate(selectedOffer.start_date) }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.end_date') }}:</span>
                                            {{ formatDate(selectedOffer.end_date) }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('offers.offer_status') }}:</span>
                                            {{ ucfirst(selectedOffer.status) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="invoice-table responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th> {{ $t('offers.total_price') }}
                                    <span class="tooltip-container ml-1">
                                        <span class="info-icon">ℹ️</span>
                                        <span class="tooltip-text">{{ $t('offers.total_price_hint') }}</span>
                                    </span>
                                </th>
                                <th>{{ $t('offers.offered_price') }}</th>
                                <th>{{ $t('offers.price_difference_pct') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="selectedOffer">
                                <td>{{ selectedOffer.currency || $t('common.none') }} {{ selectedOffer.original_price ||
                                    $t('common.none') }}
                                </td>

                                <td>{{ selectedOffer.currency || $t('common.none') }} {{ selectedOffer.offered_price ||
                                    $t('common.none') }}
                                </td>
                                <td>{{ selectedOffer.price_difference_percentage || $t('common.none') }}%
                                </td>
                            </tr>
                            <tr v-else>
                                <td colspan="5">{{ $t('common.no_data_available') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-modal>
        </div>
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner"></div>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card properties-table">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">{{ $t('offers.custom_offers') }}</h4>
                    </div>
                    <div class="card-body">
                        <div class="search-bar mb-3 search-bar-style"> <!-- Added search bar -->
                            <b>{{ $t('common.search') }}: </b>
                            <input style="border: 1px solid #dcdfe6;" type="text" v-model="serverParams.search"
                                @input="onSearch" :placeholder="$t('common.search_placeholder')" />
                        </div>
                        <vue-good-table mode="remote" @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :pagination-options="{
                                enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], nextLabel: this.$t('pagination.next'),
                                prevLabel: this.$t('pagination.Previous'),
                                rowsPerPageLabel: this.$t('pagination.rowsPerPage'),
                                ofLabel: this.$t('pagination.of'),
                            }" :rows="rows" :columns="columns" :sort-options="{
                                enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'offer_id'">
                                    <span>#{{ props.row['offer_id' + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'name'">
                                    <span>{{ props.row.user['name' + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'email'">
                                    <span>{{ props.row.user['email' + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'original_price'">
                                    <span>{{ props.row['currency' + currentLanguage] }} {{ props.row['original_price' +
                                        currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'offered_price'">
                                    <span>{{ props.row['currency' + currentLanguage] }} {{ props.row['offered_price' +
                                        currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'start_date'">
                                    <span>{{ formatDate(props.row["start_date" + currentLanguage]) }}</span>
                                </span>
                                <span v-if="props.column.field == 'end_date'">
                                    <span>{{ formatDate(props.row["end_date" + currentLanguage]) }}</span>
                                </span>
                                <span v-if="props.column.field == 'status'">
                                    <span>{{ $t('offers.status_' + props.row.status.toLowerCase()) }}</span>
                                </span>
                                <span v-if="props.column.field === 'action'"
                                    class="text-nowrap action-buttons-multiple">
                                    <b-button @click="updateStatus(props.row, 'accepted')" variant="success"
                                        class="mr-1 edit-btn">
                                        {{ $t('offers.accept') }}
                                    </b-button>
                                    <b-button @click="updateStatus(props.row, 'rejected')" variant="danger"
                                        class="mr-1 edit-btn">
                                        {{ $t('offers.reject') }}
                                    </b-button>
                                    <b-button @click="viewOfferDetails(props.row)" variant="warning"
                                        class="mr-1 edit-btn">
                                        {{ $t('offers.view_detail') }}
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue, { set } from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api';
import moment from 'moment';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
    STRIPE_STATE_NONE,
    STRIPE_STATE_PENDING,
    STRIPE_STATE_REJECTED,
    STRIPE_STATE_VERIFIED,
    resolveStripeConnectState,
    canAcceptBookingPayments,
    parseStripeErrorResponse,
} from '@/utils/stripeConnectStatus';

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            offers: [],
            searchTime: null,
            isDisabled: false,
            modalContent: '',
            selectedOffer: null,
            currentLanguage: '',
            selected: true,
            unSelected: false,
            serverParams: {
                search: "",
                sort: [
                    {
                        field: 'UserID', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],
                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: this.$t('offers.offer_id'),
                    field: 'offer_id',
                    filterable: false,
                },
                {
                    label: this.$t('register.name'),
                    field: 'name',
                    filterable: false,
                },
                {
                    label: this.$t('login.email'),
                    field: 'email',
                    filterable: false,
                },
                {
                    label: this.$t('offers.total_price'),
                    field: 'original_price',
                    filterable: false,
                },
                {
                    label: this.$t('offers.offered_price'),
                    field: 'offered_price',
                    filterable: false,
                },
                {
                    label: this.$t('Propertis.start_date'),
                    field: 'start_date',
                    filterable: false,
                },
                {
                    label: this.$t('Propertis.end_date'),
                    field: 'end_date',
                    sortable: false,
                },
                {
                    label: this.$t('offers.offer_status'),
                    field: "status",
                    sortable: false,
                },
                {
                    label: this.$t('properties_list.action'),
                    field: "action",
                    sortable: false,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            stripeConnectAccount: null,
            stripeConnectMeta: {},
            spots: [],
            ReferredBy: new Map(),
            form: {
                ReferredID: '',
            },
        };
    },
    methods: {
        updateColumnLabels() {
            this.columns.forEach(col => {
                switch (col.field) {
                    case 'property_id':
                        col.label = this.$t('offers.offer_id');
                        break;
                    case 'card_holder':
                        col.label = this.$t('Propertis.card_holder');
                        break;
                    case 'payment_id':
                        col.label = this.$t('Propertis.payment_id');
                        break;
                    case 'pdf_path':
                        col.label = this.$t('Propertis.pdf_path');
                        break;
                    case 'action':
                        col.label = this.$t('properties_list.action');
                        break;
                    default:
                        break;
                }
            });
        },
        onLanguageChanged(language) {
            if (language == 'en') {
                this.currentLanguage = '';
            } else {
                this.currentLanguage = '_' + language;
            }

        },
        formatDate(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        onSearch() {
            clearTimeout(this.searchTime);
            this.searchTime = setTimeout(() => {
                this.updateParams({ page: 1 });
                this.loadItems();
            }, 500);
        },
        editProperty(property) {
            this.$router.push({ name: 'property_id', params: { id: property.id, data: property } });
        },
        viewOfferDetails(row) {
            this.selectedOffer = row;
            this.$refs['offer-detail-modal'].show();
        },
        propertyRating(id) {
            this.$router.push({ name: 'view_rating', params: { id: id } });
        },
        dateFormat(val) {
            return moment(val).format('DD MMMM YYYY')
        },
        loadItems() {
            this.isLoading = true;
            API.getCustomOffers(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    this.isLoading = false;
                }, err => {
                    console.log(err)
                    this.isLoading = false;
                })
        },
        loadStripeConnectStatus() {
            return new Promise((resolve) => {
                API.getConnectAccount((data) => {
                    this.stripeConnectAccount = data.data || null;
                    this.stripeConnectMeta = {
                        stripe_state: data.stripe_state,
                        can_accept_payments: data.can_accept_payments,
                    };
                    const verified = canAcceptBookingPayments(this.stripeConnectAccount, this.stripeConnectMeta);
                    localStorage.setItem('stripeVerified', verified ? 'true' : 'false');
                    resolve();
                }, () => {
                    this.stripeConnectAccount = null;
                    this.stripeConnectMeta = {};
                    localStorage.setItem('stripeVerified', 'false');
                    resolve();
                });
            });
        },
        getStripeState() {
            return resolveStripeConnectState(this.stripeConnectAccount, this.stripeConnectMeta);
        },
        async ensureStripeReadyForAccept() {
            await this.loadStripeConnectStatus();
            const state = this.getStripeState();

            if (state === STRIPE_STATE_VERIFIED) {
                return true;
            }

            if (state === STRIPE_STATE_NONE) {
                const result = await this.$swal({
                    title: this.$t('stripe_connect.setup_required_title'),
                    text: this.$t('stripe_connect.setup_required_text'),
                    icon: 'info',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: this.$t('stripe_connect.setup_now'),
                    cancelButtonText: this.$t('sweetalert.cancel'),
                });
                if (result.value) {
                    this.$router.push({ path: '/add_property', query: { from: 'custom_offers', setup: 'stripe' } });
                }
                return false;
            }

            if (state === STRIPE_STATE_REJECTED) {
                await this.$swal({
                    icon: 'warning',
                    type: 'warning',
                    title: this.$t('stripe_connect.verification_rejected_title'),
                    text: this.$t('stripe_connect.verification_rejected_text'),
                });
                return false;
            }

            await this.$swal({
                icon: 'info',
                type: 'info',
                title: this.$t('stripe_connect.verification_pending_title'),
                text: this.$t('stripe_connect.verification_pending_text'),
            });
            return false;
        },
        handleAcceptStripeError(error) {
            const parsed = parseStripeErrorResponse(error);
            if (parsed.code === 'stripe_connect_required') {
                this.$swal({
                    icon: 'info',
                    type: 'info',
                    title: this.$t('stripe_connect.setup_required_title'),
                    text: parsed.message || this.$t('stripe_connect.setup_required_text'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('stripe_connect.setup_now'),
                }).then((result) => {
                    if (result.value) {
                        this.$router.push({ path: '/add_property', query: { from: 'custom_offers', setup: 'stripe' } });
                    }
                });
                return;
            }
            if (parsed.code === 'stripe_connect_pending' || parsed.code === 'stripe_connect_rejected') {
                const isRejected = parsed.code === 'stripe_connect_rejected';
                this.$swal({
                    icon: isRejected ? 'warning' : 'info',
                    type: isRejected ? 'warning' : 'info',
                    title: isRejected
                        ? this.$t('stripe_connect.verification_rejected_title')
                        : this.$t('stripe_connect.verification_pending_title'),
                    text: parsed.message || (isRejected
                        ? this.$t('stripe_connect.verification_rejected_text')
                        : this.$t('stripe_connect.verification_pending_text')),
                });
                return;
            }
            Swal.fire({
                icon: 'error',
                type: 'error',
                title: this.$t('alerts.error'),
                text: parsed.message || this.$t('alerts.error'),
                confirmButtonText: this.$t('sweetalert.OK'),
            });
        },
        async updateStatus(row, newStatus) {
            if (row.status === 'accepted' || row.status === 'rejected') {
                Swal.fire({
                    icon: 'error',
                    type: 'error',
                    title: this.$t('alerts.error'),
                    text: this.$t('alerts.action_not_allowed'),
                    confirmButtonText: this.$t('sweetalert.OK')
                });
                return;
            }

            if (newStatus === 'accepted') {
                const stripeReady = await this.ensureStripeReadyForAccept();
                if (!stripeReady) return;
            }

            const payload = {
                id: row.id,
                status: newStatus
            };
            this.isLoading = true;
            API.updateCustomOfferStatus(payload, (data) => {
                this.isLoading = false;
                if (data.message) {
                    Swal.fire({
                        icon: 'success',
                        type: 'success',
                        title: this.$t('alerts.success'),
                        text: data.message,
                        confirmButtonText: this.$t('sweetalert.OK')
                    }).then((result) => {
                        if (result.value) {
                            this.loadItems();
                        }
                    });
                } else if (data.error) {
                    this.handleAcceptStripeError(data);
                }
            }, (err) => {
                this.isLoading = false;
                if (newStatus === 'accepted') {
                    this.handleAcceptStripeError(err);
                } else {
                    console.log(err);
                }
            });
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            console.log("update param", this.serverParams);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        },
        ucfirst(str) {
            if (!str) return str; // handle empty string or undefined
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }
    },
    computed: {
        propertytype() {
            return this.$t('properties_list.Property_Type');
        },
        action() {
            return this.$t('properties_list.action');
        },
        city() {
            return this.$t('properties_list.city');
        },
        state() {
            return this.$t('properties_list.state');
        },
    },
    async mounted() {
        this.isLoading = true;
        Vue.prototype.$EventBus.$on('changeLanguage', this.updateColumnLabels);
        await this.loadStripeConnectStatus();
        this.loadItems();
        this.updateColumnLabels();

        if (this.$route.query.stripe_pending === '1') {
            await this.$swal({
                icon: 'info',
                type: 'info',
                title: this.$t('stripe_connect.verification_pending_title'),
                text: this.$t('stripe_connect.verification_pending_text'),
            });
            this.$router.replace({ path: '/custom_offers' });
        }
    },
    watch: {
        '$i18n.locale': function (newLocale, oldLocale) {
            this.columns.find(col => col.field === 'property_type').label = this.propertytype;
            this.columns.find(col => col.field === 'action').label = this.action;
            this.columns.find(col => col.field === 'city').label = this.city;
            this.columns.find(col => col.field === 'state').label = this.state;
        }
    }
}
</script>

<style>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #ccc;
    border-top-color: #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.invoice-table.responsive-table {
    overflow-x: auto;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.info-icon {
    margin-left: 5px;
    font-size: 14px;
}

.tooltip-container {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: help;
}

.tooltip-text {
    visibility: hidden;
    background-color: #333;
    color: #fff;
    text-align: left;
    padding: 6px 10px;
    border-radius: 4px;
    position: absolute;
    z-index: 9999;
    top: 125%;
    /* Show below the icon */
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.3s, visibility 0.3s;
    font-size: 13px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>